import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { v4 as uuid } from "uuid";

import { store } from "state";
import { ISearchFilter } from "types";
import { SearchFilterContainer } from "./containers";

(() => {
  const searchFilterContainers = document.querySelectorAll<HTMLElement>(
    "[data-search-filter]"
  );

  if (!searchFilterContainers) return;

  Array.from(searchFilterContainers).forEach((searchFilterContainer) => {
    const data = searchFilterContainer.dataset.searchFilter;
    const parentToolId =
      searchFilterContainer.dataset.toolboxSearchParentToolId;
    searchFilterContainer.dataset.searchFilter = "";
    searchFilterContainer.dataset.toolboxSearchParentToolId = "";

    if (!data) return undefined;

    const searchFilterData = JSON.parse(data) as ISearchFilter;

    const props = { ...searchFilterData, parentToolId };

    // we need a unique ID to distinguish state updates
    const id = uuid();

    ReactDOM.render(
      <Provider store={store}>
        <SearchFilterContainer {...props} id={id} />
      </Provider>,
      searchFilterContainer
    );
  });
})();

export {};
